import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AdminPanelProps } from '../../types';

export const AdminPanel = ({ onNavigate }: AdminPanelProps) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="column"
      alignItems="center"
      sx={{ marginTop: '20px', gap: '10px' }}
    >
      <Button variant="contained" color="primary" onClick={onNavigate}>
        {t('profilePage.adminPanel')}
      </Button>
    </Stack>
  );
}; 